import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { listenToControls, patchWarningRistorni, registerWarningGreaterThanField, updateWarningGHISuperioriB } from '../validators/helpers/dati-bilancio-form.helpers';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { isNilOrEmpty, nz } from '@shared/helpers/utils.helper';

export const datiBilancioRistorniWarningsListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_WarningsRistorniSuperioriB(form, store);
    my_WarningsRistorniSuperiori30PerCentoC(form, store);
    my_WarningsRistorniSuperioriCEB9(form, store);
    my_WarningsRistorniGHISuperioriB(form, store);
};

const my_WarningsRistorniSuperioriB = (form: FormGroup, store: Store<Revisione53State>): void => {
    registerWarningGreaterThanField(form, store, 'my_CkApplicatiRistorni', 'my_RistornoCoopLav', 'my_AvanzoDiGestionePrevalenza', 'my_CkDSuperioreB');
    registerWarningGreaterThanField(form, store, 'my_CkApplicatiRistorni', 'my_RistornoCoopUt', 'my_AvanzoDiGestionePrevalenza', 'my_CkESuperioreB', false);
    registerWarningGreaterThanField(form, store, 'my_CkApplicatiRistorni', 'my_RistornoCoopAp', 'my_AvanzoDiGestionePrevalenza', 'my_CkFSuperioreB', false);
    registerWarningGreaterThanField(form, store, 'my_CkApplicatiRistorni', 'my_ImportoLiquidazioniSalariali', 'my_AvanzoDiGestionePrevalenza', 'my_CkGSuperioreB', false);
    registerWarningGreaterThanField(form, store, 'my_CkApplicatiRistorni', 'my_ImportoAumentoGratuito', 'my_AvanzoDiGestionePrevalenza', 'my_CkHSuperioreB', false);
    registerWarningGreaterThanField(form, store, 'my_CkApplicatiRistorni', 'my_ImportoDistribuzioneGratuita', 'my_AvanzoDiGestionePrevalenza', 'my_CkISuperioreB', false);
    registerWarningGreaterThanField(form, store, 'my_CkApplicaRistorniAnno1', 'my_RistornoCoopLavAnno1', 'my_AvanzoDiGestionePrevalenzaAnno1', 'my_CkDSuperioreBAnno1');
    registerWarningGreaterThanField(form, store, 'my_CkApplicaRistorniAnno1', 'my_RistornoCoopUtAnno1', 'my_AvanzoDiGestionePrevalenzaAnno1', 'my_CkESuperioreBAnno1', false);
    registerWarningGreaterThanField(form, store, 'my_CkApplicaRistorniAnno1', 'my_RistornoCoopApAnno1', 'my_AvanzoDiGestionePrevalenzaAnno1', 'my_CkFSuperioreBAnno1', false);
    registerWarningGreaterThanField(
        form,
        store,
        'my_CkApplicaRistorniAnno1',
        'my_ImportoLiquidazioniSalarialiAnno1',
        'my_AvanzoDiGestionePrevalenzaAnno1',
        'my_CkGSuperioreBAnno1',
        false
    );
    registerWarningGreaterThanField(
        form,
        store,
        'my_CkApplicaRistorniAnno1',
        'my_ImportoAumentoGratuitoAnno1',
        'my_AvanzoDiGestionePrevalenzaAnno1',
        'my_CkHSuperioreBAnno1',
        false
    );
    registerWarningGreaterThanField(
        form,
        store,
        'my_CkApplicaRistorniAnno1',
        'my_ImportoDistribuzioneGratuitaAnno1',
        'my_AvanzoDiGestionePrevalenzaAnno1',
        'my_CkISuperioreBAnno1',
        false
    );
};

const my_WarningsRistorniSuperiori30PerCentoC = (form: FormGroup, store: Store<Revisione53State>): void => {
    registerWarningGreaterThanField(form, store, 'my_CkApplicatiRistorni', 'my_RistornoCoopLav', 'my_valida30PercentoRistorno', 'my_CkDSuperiore30PerCentoC');

    registerWarningGreaterThanField(form, store, 'my_CkApplicaRistorniAnno1', 'my_RistornoCoopLavAnno1', 'my_valida30PercentoRistornoAnno1', 'my_CkDSuperiore30PerCentoCAnno1');
};

const my_WarningsRistorniSuperioriCEB9 = (form: FormGroup, store: Store<Revisione53State>): void => {
    registerWarningGreaterThanContoEconomicoSum(form, store, 'my_CkApplicatiRistorni', 'my_RistornoCoopLav', 'my_CoEcB9tot2', 'my_CoEcB72', 'my_CkDSuperioreCEB9');

    registerWarningGreaterThanContoEconomicoSum(form, store, 'my_CkApplicaRistorniAnno1', 'my_RistornoCoopLavAnno1', 'my_CoEcB9tot1', 'my_CoEcB71', 'my_CkDSuperioreCEB9Anno1');
};

const registerWarningGreaterThanContoEconomicoSum = (
    form: FormGroup,
    store: Store<Revisione53State>,
    flagField: string,
    sourceField: string,
    firstCompareField: string,
    secondCompareField: string,
    targetField: string
): void => {
    const bilancioGroup = getGroup(form, formPaths.bilancio);
    const schedaRistorniGroup = getGroup(bilancioGroup, 'my_SchedaRistorni');
    const contoEconomicoGroup = getGroup(form, `${formPaths.datiBilancio}.my_ContoEconomico`);

    const flagControl = getControl(bilancioGroup, flagField);
    const sourceControl = getControl(schedaRistorniGroup, sourceField);
    const firstCompareControl = getControl(contoEconomicoGroup, firstCompareField);
    const secondCompareControl = getControl(contoEconomicoGroup, secondCompareField);

    listenToControls([flagControl, sourceControl, firstCompareControl, secondCompareControl], () => {
        const result =
            flagControl.value === '1' &&
            !isNilOrEmpty(sourceControl.value) &&
            !isNilOrEmpty(firstCompareControl.value) &&
            !isNilOrEmpty(secondCompareControl.value) &&
            nz(sourceControl.value) > nz(firstCompareControl.value) + nz(secondCompareControl.value)
                ? '1'
                : '0';

        patchWarningRistorni(form, store, targetField, result);
    });
};

const my_WarningsRistorniGHISuperioriB = (form: FormGroup, store: Store<Revisione53State>): void => {
    registerWarningGHISuperioriB(
        form,
        store,
        'my_ImportoLiquidazioniSalariali',
        'my_ImportoAumentoGratuito',
        'my_ImportoDistribuzioneGratuita',
        'my_AvanzoDiGestionePrevalenza',
        'validaVerificaDelibere',
        'my_CkGHISuperioriB'
    );

    registerWarningGHISuperioriB(
        form,
        store,
        'my_ImportoLiquidazioniSalarialiAnno1',
        'my_ImportoAumentoGratuitoAnno1',
        'my_ImportoDistribuzioneGratuitaAnno1',
        'my_AvanzoDiGestionePrevalenzaAnno1',
        'validaVerificaDelibereAnno1',
        'my_CkGHISuperioriBAnno1'
    );
};

const registerWarningGHISuperioriB = (
    form: FormGroup,
    store: Store<Revisione53State>,
    importoLiquidazioniField: string,
    importoAumentoField: string,
    importoDistribuzioneField: string,
    avanzoField: string,
    validaVerificaDelibereField: string,
    targetField: string
): void => {
    const schedaRistorniGroup = getGroup(form, `${formPaths.bilancio}.my_SchedaRistorni`);

    const importoLiquidazioniControl = getControl(schedaRistorniGroup, importoLiquidazioniField);
    const importoAumentoControl = getControl(schedaRistorniGroup, importoAumentoField);
    const importoDistribuzioneControl = getControl(schedaRistorniGroup, importoDistribuzioneField);
    const avanzoControl = getControl(schedaRistorniGroup, avanzoField);
    const validaVerificaDelibereControl = getControl(schedaRistorniGroup, validaVerificaDelibereField);

    listenToControls([importoLiquidazioniControl, importoAumentoControl, importoDistribuzioneControl, avanzoControl, validaVerificaDelibereControl], () => {
        updateWarningGHISuperioriB(form, store, avanzoField, validaVerificaDelibereField, targetField);
    });
};
